/* Medallion cart preview — Oracle 2026-08-06
   Re-renders the personalized engraving preview onto medallion line-item
   thumbnails in the cart drawer, cart page, and add-to-cart notification.
   Reads data-mg-* attributes stamped by the theme liquid on each <img>.
   Config: window.MGMockupImgs = { 'red-heart': url, ... } (set by liquid snippet). */
(function () {
  if (window.__mgCartPreviewInit) return;
  window.__mgCartPreviewInit = true;

  var CFG = {
    'red-heart':   { qr: [0.3343, 0.3509, 0.6750, 0.6944], color: '#E8E3DC', shape: 'heart' },
    'black-heart': { qr: [0.3296, 0.3481, 0.6796, 0.6972], color: '#E8E3DC', shape: 'heart' },
    'white-heart': { qr: [0.3426, 0.3500, 0.6759, 0.6991], color: '#B7B1AE', shape: 'heart' },
    'black-square':{ qr: [0.3574, 0.3398, 0.6537, 0.6333], color: '#E8E3DC', shape: 'square' }
  };
  var RATIOS = {
    heart:  { nameFont: 0.150, nameBase: 0.166, yrFont: 0.100, yrBase: 0.050, maxW: 1.90 },
    square: { nameFont: 0.131, nameBase: 0.159, yrFont: 0.078, yrBase: 0.051, maxW: 1.40 }
  };
  var SIZE = 600;
  var imgCache = {};

  // ensure Libre Baskerville is available in this document
  (function ensureFont() {
    var have = false;
    document.querySelectorAll('link[href*="Libre+Baskerville"]').forEach(function () { have = true; });
    if (!have) {
      var l = document.createElement('link');
      l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Libre+Baskerville:wght@400;700&display=swap';
      document.head.appendChild(l);
    }
  })();

  function keyFor(val) {
    val = String(val || '');
    if (/square/i.test(val)) return 'black-square';
    if (/white/i.test(val)) return 'white-heart';
    if (/black/i.test(val)) return 'black-heart';
    return 'red-heart';
  }

  function loadBlank(key, cb) {
    var urls = window.MGMockupImgs || {};
    if (!urls[key]) return;
    if (imgCache[key]) {
      if (imgCache[key].complete && imgCache[key].naturalWidth) cb(imgCache[key]);
      else imgCache[key].addEventListener('load', function () { cb(imgCache[key]); });
      return;
    }
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.src = urls[key];
    imgCache[key] = im;
    im.addEventListener('load', function () { cb(im); });
  }

  function drawText(ctx, text, bold, px, baselineY, cx, color, maxWpx) {
    if (!text) return;
    ctx.save();
    ctx.font = (bold ? '700 ' : '') + px + 'px "Libre Baskerville", Baskerville, Georgia, serif';
    var w = ctx.measureText(text).width;
    if (w > maxWpx) {
      px = Math.floor(px * maxWpx / w);
      ctx.font = (bold ? '700 ' : '') + px + 'px "Libre Baskerville", Baskerville, Georgia, serif';
    }
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = color;
    ctx.globalAlpha = 0.96;
    ctx.shadowColor = 'rgba(0,0,0,0.35)';
    ctx.shadowBlur = 1;
    ctx.fillText(text, cx, baselineY);
    ctx.restore();
  }

  function renderInto(imgEl) {
    var name = (imgEl.getAttribute('data-mg-name') || '').trim();
    var birth = (imgEl.getAttribute('data-mg-birth') || '').trim();
    var pass = (imgEl.getAttribute('data-mg-pass') || '').trim();
    var key = keyFor(imgEl.getAttribute('data-mg-variant'));
    var sig = key + '|' + name + '|' + birth + '|' + pass;
    if (imgEl.getAttribute('data-mg-done') === sig) return;
    if (!name && !birth && !pass) return; // nothing personalized; leave product photo
    loadBlank(key, function (blank) {
      try {
        var cfg = CFG[key], rat = RATIOS[cfg.shape];
        var c = document.createElement('canvas');
        c.width = SIZE; c.height = SIZE;
        var ctx = c.getContext('2d');
        ctx.drawImage(blank, 0, 0, SIZE, SIZE);
        var qx0 = cfg.qr[0] * SIZE, qy0 = cfg.qr[1] * SIZE, qx1 = cfg.qr[2] * SIZE;
        var S = qx1 - qx0, cx = (qx0 + qx1) / 2;
        var years = '';
        if (birth || pass) years = (birth || '') + '-' + (pass || '');
        drawText(ctx, name, false, Math.round(rat.nameFont * S), qy0 - rat.nameBase * S, cx, cfg.color, rat.maxW * S);
        drawText(ctx, years, true, Math.round(rat.yrFont * S), qy0 - rat.yrBase * S, cx, cfg.color, rat.maxW * S);
        var url = c.toDataURL('image/jpeg', 0.85);
        imgEl.removeAttribute('srcset');
        imgEl.removeAttribute('sizes');
        imgEl.src = url;
        var w = imgEl.getAttribute('width');
        if (w) imgEl.setAttribute('height', w); // our preview is square
        imgEl.style.aspectRatio = '1 / 1';
        imgEl.style.objectFit = 'cover';
        imgEl.setAttribute('data-mg-done', sig);
      } catch (e) { /* tainted canvas or other failure: leave original image */ }
    });
  }

  var scheduled = false;
  function scan() {
    scheduled = false;
    document.querySelectorAll('img[data-mg-preview]').forEach(renderInto);
  }
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(scan, 60);
  }

  function start() {
    scan();
    if (document.fonts && document.fonts.load) {
      Promise.all([
        document.fonts.load('400 40px "Libre Baskerville"'),
        document.fonts.load('700 40px "Libre Baskerville"')
      ]).then(function () {
        document.querySelectorAll('img[data-mg-preview]').forEach(function (el) { el.removeAttribute('data-mg-done'); });
        scheduleScan();
      });
    }
    var mo = new MutationObserver(scheduleScan);
    mo.observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
